module.exports = __webpack_public_path__ + "static/media/share-alt-square.d93a4cde.svg";